import {
  REQUEST_PAGE,
  RECEIVE_PAGE,
  REQUEST_PAGED_PAGES,
  RECEIVE_PAGED_PAGES
} from "./page.actions";

const requestPage = () => {
  return {
      type: REQUEST_PAGE
  };
};

const receivePage = singlePage => {
  return {
      type: RECEIVE_PAGE,
      singlePage
  };
};

const requestPagedPages = () => {
  return {
      type: REQUEST_PAGED_PAGES
  };
};

const receivePagedPages = pages => {
  return {
      type: RECEIVE_PAGED_PAGES,
      pages
  };
};

export { requestPage, receivePage, requestPagedPages, receivePagedPages };



// WEBPACK FOOTER //
// ./src/actions/page/page.creators.js